import React from 'react'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import { withStyles } from '@material-ui/core/styles'
import FormInfo from '../FormInfo'
import Logo from '../Logo'
import LandingPage from '../LandingPage'
import styles from 'components/AddOrEditTaskPage/styles'
import { toggleBottomMenu } from 'actions/signupForm/addOrEdit'
import BottomNav from './BottomNav'
import Main from './Main'
import CustomIntegrationPreview from '../Main/CustomIntegrationPreview'

const MobileForm_index = connect(
  state => ({
    bottomNavigation: state.signupForm.addOrEdit.bottomNav,
    bottomMenuOpen: state.signupForm.addOrEdit.bottomMenuOpen,
    formTypeSelected: state.signupForm.addOrEdit.formTypeSelected,
  }),
  dispatch => bindActionCreators({ toggleBottomMenu }, dispatch),
)(
  withStyles(styles)(
    ({
      bottomNavigation,
      classes,
      toggleBottomMenu,
      bottomMenuOpen,
      formTypeSelected,
    }) => {
      const BottomMenu = () => {
        switch (bottomNavigation) {
          case 0:
            return formTypeSelected === 'customIntegration' ? (
              <CustomIntegrationPreview />
            ) : (
              <Main />
            )
          case 1:
            return <FormInfo />
          case 2:
            return <Logo />
          case 3:
            return <LandingPage />
          default:
            return formTypeSelected === 'customIntegration' ? (
              <CustomIntegrationPreview />
            ) : (
              <Main />
            )
        }
      }

      return (
        <div>
          <BottomMenu />
          <BottomNav />
        </div>
      )
    },
  ),
)

export default MobileForm_index